






import Vue from "vue";

import IconCheckbox from "@joyz/app-core/assets/icons/default/Checkbox.svg";
import IconCheckboxActive from "@joyz/app-core/assets/icons/active/Checkbox.svg";

interface Data {
  icons: { [key: string]: string };
}

interface Computed {
  icon: string;
}

interface Props {
  checked: boolean;
}

export default Vue.extend<Data, unknown, Computed, Props>({
  name: "JzCheckbox",
  props: {
    checked: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      icons: {
        checkbox: IconCheckbox,
        checkboxActive: IconCheckboxActive
      }
    };
  },
  computed: {
    icon() {
      return this.checked ? this.icons.checkboxActive : this.icons.checkbox;
    }
  }
});
